import Image from 'next/image';
import React from 'react';

import fallbackImg from '../../../assets/images/camera.png';

export const DefaultFallback: React.FC<{ className?: string }> = ({ className = '' }) => (
  <Image src={fallbackImg} alt="Fallback image" className={className} />
);
